export default __webpack_public_path__ + "static/media/line-image.8b351896.svg";